import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface CreateFileTypeOptionProps {
  title: string;
  description: string;
  icon: ReactNode;
  selected: boolean;
  onClick: () => void;
}

export const CreateFileTypeOption = ({
  title,
  description,
  icon,
  selected,
  onClick,
}: CreateFileTypeOptionProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "flex min-w-0 flex-1 items-start gap-2.5 rounded-md border px-3 py-2.5 text-left transition-colors",
      selected
        ? "border-blue-300 bg-blue-50 shadow-sm"
        : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50",
    )}
  >
    <div
      className={cn(
        "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md",
        selected ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-500",
      )}
    >
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-sm font-medium text-gray-900">{title}</p>
      <p className="mt-0.5 text-xs leading-5 text-gray-500">{description}</p>
    </div>
  </button>
);
